import React, { useEffect, useState } from 'react';
import { Users, X, CheckCircle2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Zeigt oben auf der Landing „Empfohlen von {Firma}"-Banner,
 * wenn URL `?ref=CODE` enthält. Dismissible.
 */
export const ReferralBanner = () => {
  const [name, setName] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref) return;
    // Session-Storage merkt sich Ref für Register-Formular
    try { sessionStorage.setItem('sv_ref', ref); } catch { /* noop */ }
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/referral/lookup/${encodeURIComponent(ref)}`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.success && data.referrer_name) setName(data.referrer_name);
      } catch { /* fail silently */ }
    })();
  }, []);

  if (!name || dismissed) return null;

  return (
    <div
      className="fixed top-[68px] left-0 right-0 z-30 bg-gradient-to-r from-yellow-500/95 via-amber-500/95 to-yellow-500/95 text-black shadow-lg animate-in fade-in slide-in-from-top duration-500"
      data-testid="referral-banner"
      role="status"
    >
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Users className="w-5 h-5 shrink-0" />
          <p className="text-sm font-bold truncate">
            <span className="hidden sm:inline">🎁 </span>
            Empfohlen von <span className="underline decoration-2">{name}</span>
            <span className="hidden md:inline"> — du bekommst 1 Monat gratis bei deinem ersten Abo!</span>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className="hidden sm:inline-flex items-center gap-1 bg-black/15 rounded-full px-2.5 py-1 text-xs font-black">
            <CheckCircle2 className="w-3.5 h-3.5" /> 30 Tage Bonus
          </span>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-black/10 rounded"
            aria-label="Banner ausblenden"
            data-testid="referral-banner-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralBanner;
